import { render, staticRenderFns } from "./CobranzaView.vue?vue&type=template&id=b64e654c&scoped=true"
import script from "./CobranzaView.vue?vue&type=script&lang=js"
export * from "./CobranzaView.vue?vue&type=script&lang=js"
import style0 from "./CobranzaView.vue?vue&type=style&index=0&id=b64e654c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b64e654c",
  null
  
)

export default component.exports